import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import $ from "jquery";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import AddPalestinianGovernoratesProjectActivities from "../../../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/PalestinianGovernoratesProjectActivities/AddPalestinianGovernoratesProjectActivities";
import UpdatePalestinianGovernoratesProjectActivities from "../../../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/PalestinianGovernoratesProjectActivities/UpdatePalestinianGovernoratesProjectActivities";
import {
  GetOnePalestinianGovernoratesProjectActivities,
  restValidationPalList,
  ValidateOnePalestinianGovernoratesProjectActivities,
} from "../../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/GetOnePalestinian/indexOne";
import {
  GetAllTG_PalestinianGovernoratesName,
  GetListPalestinianGovernorates,
} from "../../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject/DropDowntPalestinianGovernorates";
import Swal from "sweetalert2";

const AddEditPalestinianGovernoratesProjectActivities = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownPalestinianGovernoratesName:
        state.DropDownPalestinianGovernoratesName
          .DropDownPalestinianGovernoratesName,

      PalestinianGovernoratesList:
        state.DropDownPalestinianGovernoratesName.PalestinianGovernoratesList,

      TargetInfo: state.TargetInfo.TargetInfo,
      OnePalestinianGovernoratesProjectActivities:
        state.OnePalestinianGovernoratesProjectActivities
          .OnePalestinianGovernoratesProjectActivities,
      loadingOnePalestinianGovernoratesProjectActivities:
        state.OnePalestinianGovernoratesProjectActivities
          .loadingOnePalestinianGovernoratesProjectActivities,
      tG_MainTargetedGroupId:
        state.TargetInfo.TargetInfo.tG_MainTargetedGroupId,
      ValidateOnePalestinianGovernoratesProjectActivities:
        state.OnePalestinianGovernoratesProjectActivities
          .ValidateOnePalestinianGovernoratesProjectActivities,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  // Define the initial state for the  governorates list

  const [palestineList, setpalestineList] = useState({
    tG_PalestinianGovernoratesProjectActivitiesId:
      state.OnePalestinianGovernoratesProjectActivities
        ?.tG_PalestinianGovernoratesProjectActivitiesId,
    tG_PalestinianGovernoratesNameId:
      state.OnePalestinianGovernoratesProjectActivities
        ?.tG_PalestinianGovernoratesNameId,
    tG_MainTargetedGroupId: state.tG_MainTargetedGroupId,
  });

  //console.log(state.OneInformationAboutTheTargetGroupOfTheProject, "dd");
  // Fetch all governorate names when the component is mounted
  useEffect(() => {
    dispatch(GetAllTG_PalestinianGovernoratesName());
  }, []);

  // const AddPalestinian = async () => {
  //   await AddPalestinianGovernoratesProjectActivities(
  //     palestineList.tG_PalestinianGovernoratesNameId,
  //     state.tG_MainTargetedGroupId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };

  useEffect(() => {
    dispatch(GetListPalestinianGovernorates(state.tG_MainTargetedGroupId));
  }, []);
  // Function to add a new  governorate to the project

  const AddPalestinian = async () => {
    const validationList = await dispatch(
      ValidateOnePalestinianGovernoratesProjectActivities({
        tG_PalestinianGovernoratesNameId:
          palestineList.tG_PalestinianGovernoratesNameId,
      })
    );

    const isDuplicate = state.PalestinianGovernoratesList.some(
      (sector) =>
        sector.tG_PalestinianGovernoratesNameId ==
        palestineList.tG_PalestinianGovernoratesNameId
    );

    if (isDuplicate) {
      // Show an error alert if the governorate is already selected

      Swal.fire({
        position: "center",
        icon: "error",
        title: "لا يمكنك اختيار هذه المحافظة مرة اخرى",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
    // Proceed if the validation list is empty
    if (validationList.payload.length === 0) {
      await AddPalestinianGovernoratesProjectActivities(
        palestineList.tG_PalestinianGovernoratesNameId,
        state.tG_MainTargetedGroupId
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    dispatch(restValidationPalList());
  }, []);
  // Function to update an existing Jordanian governorate
  const UpdatePalsetinian = async () => {
    const isDuplicate = state.PalestinianGovernoratesList.some(
      (sector) =>
        sector.tG_PalestinianGovernoratesNameId ==
        palestineList.tG_PalestinianGovernoratesNameId
    );

    if (isDuplicate) {
      // Show an error alert if the governorate is already selected

      Swal.fire({
        position: "center",
        icon: "error",
        title: "لا يمكنك اختيار هذه المحافظة مرة اخرى",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
    await UpdatePalestinianGovernoratesProjectActivities(
      palestineList.tG_PalestinianGovernoratesProjectActivitiesId,

      palestineList.tG_PalestinianGovernoratesNameId,

      palestineList.tG_MainTargetedGroupId
    );
    $(".close-btn").trigger("click");
    Swal.fire({
      position: "center",
      icon: "success",
      title: "تم تعديل المعلومات بنجاح",
      showConfirmButton: false,
      timer: 1500,
      // width: "500px",
    });
    dispatch(setRefreshTable());
  };
  // Fetch a specific governorate's data when the component is loaded
  useEffect(() => {
    if (props != null) {
      dispatch(
        GetOnePalestinianGovernoratesProjectActivities(
          props.tG_PalestinianGovernoratesProjectActivitiesId
        )
      );
    }
  }, [props.tG_PalestinianGovernoratesProjectActivitiesId]);
  useEffect(() => {
    if (
      !state.loadingOnePalestinianGovernoratesProjectActivities &&
      Object.keys(props).length != 0
    ) {
      setpalestineList({
        ...state.OnePalestinianGovernoratesProjectActivities,
      });
    } else {
      setpalestineList({
        tG_PalestinianGovernoratesNameId: null,
        tG_MainTargetedGroupId: state.tG_MainTargetedGroupId,
      });
    }
  }, [state.OnePalestinianGovernoratesProjectActivities]);

  return (
    <>
      {!state.loadingOnePalestinianGovernoratesProjectActivities ? (
        <>
          <div className="AddEdite">
            <AllDropDownsAHSF
              fieldsName="city"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownPalestinianGovernoratesName}
              KeyText={"palestinianGovernoratesNameAr"}
              KeyValue={"tG_PalestinianGovernoratesNameId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setpalestineList({
                  ...palestineList,
                  tG_PalestinianGovernoratesNameId: Number(e.target.value),
                });
              }}
              defaultValue={palestineList.tG_PalestinianGovernoratesNameId}
              showValidationMessage={
                state.ValidateOnePalestinianGovernoratesProjectActivities
                  ? state.ValidateOnePalestinianGovernoratesProjectActivities.includes(
                      "city"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdatePalsetinian()
                        : AddPalestinian();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF
        show={state.loadingOnePalestinianGovernoratesProjectActivities}
      />
    </>
  );
};

export default AddEditPalestinianGovernoratesProjectActivities;
